import Box from "@mui/material/Box";
import IconButton from '@mui/material/IconButton';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
// import LastPageIcon from '@mui/icons-material/LastPage';
import { SxProps, Theme, useTheme } from '@mui/material/styles';
import { Stack, TableCell } from "@mui/material";

type TablePaginationActionsProps = {
  count: number
  page: number
  rowsPerPage: number
  colSpan: number
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void
  whiteBackgroundClr?: boolean
  applyBorderRadius?: boolean
}

const ArrowIconStyles: SxProps<Theme> = {
  borderRadius: "4px",
  border: "1px solid #F0E4F8",
  backgroundColor: "#F0F1FA",
  color: "var(--clr-primary-dark-violet)",
  lineHeight: "16px",
  height: "16px",
  width: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ":hover": {

  }
}

const selectedNumberButtonStyles: SxProps<Theme> = {
  border: "1px solid #C599E5",
  backgroundColor: "#F0F1FA",
}

const numberButtonStyles: SxProps<Theme> = {
  borderRadius: "4px",
  color: "var(--clr-grey-1)",
  fontSize: "14px",
  lineHeight: "20px",
  height: "20px",
  width: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ":hover": selectedNumberButtonStyles,
}


function TablePaginationActions(props: TablePaginationActionsProps) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange, colSpan, whiteBackgroundClr, applyBorderRadius } = props;
  const pageCount: number = 6,
    pageOffset: number = Math.ceil((page + 1) / pageCount),
    pages: number[] = Array(pageCount)
      .fill(0)
      .map((_, index) => (index) + (pageOffset - 1) * pageCount),
    totalPages: number = Math.ceil(count / rowsPerPage) || 1;

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  return (
    <TableCell sx={{ backgroundColor: whiteBackgroundClr ? "white" : "var(--body-bg-clr)", borderBottomWidth: 0, borderRadius: applyBorderRadius ? "8px" : "0", padding: "16px 16px 16px 0" }} colSpan={colSpan} align="right">
      <Box sx={{ flexShrink: 0, ml: 2.5 }} display={"flex"} gap={1} alignItems={"center"} justifyContent={"end"}>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
          sx={ArrowIconStyles}
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <Stack direction={"row"} gap={1} display={"inline-flex"}>
          {pages
            .filter(x => x < totalPages)
            .map(p => <NumberButton
              selected={p === page}
              key={p}
              number={p + 1}
              onClick={(event) => onPageChange(event, p)}
            />)}
        </Stack>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
          sx={ArrowIconStyles}
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
      </Box>
    </TableCell>
  );
}

export default TablePaginationActions;

type NumberButtonProps = {
  selected: boolean
  number: number
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

function NumberButton(props: NumberButtonProps) {
  const { number, onClick, selected } = props;
  const conditionalStyles: SxProps<Theme> = selected ? selectedNumberButtonStyles : {};
  const sx: SxProps<Theme> = Object.assign({
    ...numberButtonStyles,
    ...conditionalStyles,
  })

  return (
    <IconButton
      onClick={onClick}
      sx={sx} >
      {number}
    </IconButton>
  )
}